<template>
  <div>
    <br />
    <br />
    <br />
    <center>
      <h1 class="title">Ooops, page not found!</h1>
      <p>The page you are looking for was moved, removed, renamed or might have never existed.</p>
      <br />
      <br />
      <b-button class="is-warning" tag="router-link" to="/" type="is-link">Go Home</b-button>
    </center>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
